import { h } from 'preact';
import Store from 'store/store';
import * as jsonPointer from 'utils/jsonPointer';

import FieldBase from 'components/editor/settings/fieldBase';
import Dropdown from 'components/dropdown/dropdown';

import s from 'components/editor/settings/dropdownField.sss';

export default class DropdownField extends FieldBase {
	s = s;

	constructor(props) {
		super(props);

		this.onChange = this.onChange.bind(this);
	}

	get labelFor() {
		return null;
	}

	onChange(e) {
		this.props.onChange?.(e);
		if (!this.props.path) return;
		jsonPointer.setDeep(Store.get().data, this.props.path, e.target.value);
	}

	renderField() {
		const props = this.props;
		return (
			<Dropdown
				class={s.field}
				dark={props.dark}
				align={props.align || 'full'}
				name={this.state.id}
				value={this.value}
				allowEmpty
				placeholder={this.placeholder}
				initialValue={props.initialValue}
				searchable={props.searchable}
				searchPlaceholder={props.searchPlaceholder}
				disabled={this.disabled || this.readonly}
				onChange={this.onChange}
			>
				{this.props.children}
			</Dropdown>
		);
	}
}